module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedMedium.020ab2d.eot";